import React from 'react';

export default ({ icon, left, ...props }) => (
  <span className={`webchat_control ${left ? 'left' : 'right'}`} {...props}>
    <i className={icon}></i>
  </span>
);
